/**
 * EvidenceDisplay Constants
 * Size presets, colors, and default configurations
 */

export const PRIMARY_COLOR = '#2266EF';

export const SIZE_PRESETS = {
  sm: {
    width: '24px',
    height: '32px',
    gap: '2px',
    borderRadius: '6px',
  },
  md: {
    width: '32px',
    height: '42px',
    gap: '8px',
    borderRadius: '8px',
  },
  lg: {
    width: '40px',
    height: '60px',
    gap: '12px',
    borderRadius: '8px',
  },
};

export const DEFAULT_CONFIG = {
  size: 'md',
  showGallery: true,
  isLoading: false,
};

export const BORDER_COLOR = '#d3e0fc';
export const BACKGROUND_COLOR = 'white';
export const EMPTY_STATE = '-';
